const schema = {
    dataReativacao: {
        id: 'dataReativacao',
        label: 'Data de reativação',
        mask: '',
        required: true,
        type: 'date',
        requiredMessage: '',
    },
    novoPlano: {
        id: 'novoPlano',
        label: 'Novo plano',
        mask: '',
        required: true,
        type: 'select',
        requiredMessage: '',
    },
    tipoReativacao: {
        id: 'tipoReativacao',
        label: 'Reativar',
        mask: '',
        required: true,
        type: 'radio',
        value: '',
        options: [
            { codigo: 'T', nome: 'Somente titular' },
            { codigo: 'D', nome: 'Titular e dependentes' },
        ],
    },
};

export default schema;
